import React from 'react';
import { IconProps } from '.';

const SvgColoredFingerFive = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FFD653'
        d='M21.28 10.76c-.92-.41-2.24.14-3.18 1.46-.61.87-.79 2.11-1.6 2.24-.31.05-.48-.14-.56-.41-.09-.46-.07-1.16.1-2.14l1.83-8.24c.15-.63-.2-1.24-1.02-1.44-.82-.2-1.44.2-1.59.83l-1.64 7.47c-.33 1.65-.94 1.35-.79-.52l.47-8.76C13.34.58 12.82.03 12.05 0c-.77-.03-1.32.43-1.36 1.11l-.45 8.97c-.1 1.81-.74 1.13-.88-.18L8.32 2.64c-.11-.68-.75-1.16-1.52-1.03-.77.12-1.23.76-1.13 1.44l1 6.63c.4 2.53-.12 3.23-.98.48L4.62 6.13c-.17-.65-.81-1.05-1.61-.82-.8.22-1.15.87-.97 1.52l1.04 3.79c.44 2.73.44 3.81.44 5.68 0 1.87.86 7.7 7.47 7.7 6.61 0 7.97-6.71 8.03-7.14 0 0 .08-.99.77-1.92.98-1.32 1.67-2.11 2.09-2.59.21-.24.42-1.14-.61-1.6l.01.01Z'
      />
      <path
        fill='#EC8A3C'
        d='M16.29 14.46c-.2-.08-.37-.29-.39-.75-1.27.17-2.98.53-4.3 1.82-1.71 1.67-2 3.48-1.99 4.69.01.98.54 1.44.7 0 .2-1.82 1.53-5.45 5.98-5.75v-.01Z'
      />
    </svg>
  );
};

export default SvgColoredFingerFive;
